module.exports = __webpack_public_path__ + "img/mq.97dfaf62.svg";